import React from 'react';

const QueryContext = React.createContext(null);

export default QueryContext;